import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.decimo.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionPesquisaTrabalhador = ({dispatch},payload)=>{
    return serves.decimo.pesquisatrabalhador(payload).then(res => {
        dispatch('ActionSetTrabalhador',res)
    }).catch(err => {
        dispatch('ActionSetTrabalhador',err)
    })
}
export const ActionBuscaTrabalhador = ({dispatch},payload)=>{
    return serves.decimo.buscatrabalhador(payload).then(res => {
        dispatch('ActionSetTrabalhador',res)
    }).catch(err => {
        dispatch('ActionSetTrabalhador',err)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.decimo.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.decimo.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.decimo.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.decimo.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionRescisaoUpdate = ({dispatch},payload)=>{
    return serves.decimo.rescisaoupdate(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEvento = ({dispatch},payload)=>{
    return serves.decimo.evento(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}

export const ActionEventoCadastro = ({dispatch},payload)=>{
    return serves.decimo.eventocadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEmail = ({dispatch},payload)=>{
    return serves.decimo.email(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}

export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetId = ({commit},payload) =>{
    commit(types.SET_ID,payload)
}
export const ActionSetTrabalhador = ({commit},payload) =>{
    commit(types.SET_TRABALHADOR,payload)
}